<template>
  <div class="error">
    <div class="nav">
      <p>{{ $t('notFound.notFound') }}</p>
      <span>{{ $t('notFound.YMWZD') }}</span>
      <el-button @click="handleGoback" type="text">{{ $t('notFound.FHSYY') }}</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: '404',
    methods:{
        handleGoback(){
            this.$router.go(-1)
        }
    }
}
</script>
<style scoped lang="scss">
  .error{
    background: #F4F4F4;
    height: 99vh;
    border: solid 1px #f4f4f4;
    .nav{
      width: 400px;
      margin: 0 auto;
      text-align: center;
      p{
        font-size: 150px;
        color: #CCCCCC;
      }
      span{
        color: #CCCCCC;
      }
    }
  }
</style>
